import FormStep, { FormFields, FormStepControls } from "../FormStep";
import { communityFields } from "./fields";

export default function CommunityStep(props) {
  const { step, goNext, goPrev, isLoading, ...otherProps } = props;

  return (
    <FormStep
      step={step}
      title="Tell us about your community"
      sideTitle={"Build your own brand"}
      sideDescription={
        "with beautiful payment pages, personalised marketing & the best SEO practices"
      }
      sideImage={"/assets/illustrations/onboarding-2.svg"}
    >
      <FormFields fields={communityFields} {...otherProps} />

      <FormStepControls
        isLoading={isLoading}
        step={step}
        goNext={goNext}
        goPrev={goPrev}
      />
    </FormStep>
  );
}
